import SectionTilesList from './SectionTilesList'

export default SectionTilesList
// eslint-disable-next-line import/export
export * from './SectionTilesList'
